var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#B9C0C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 43.75a3.75 3.75 0 110-7.5 3.75 3.75 0 010 7.5zm-10.5 0a3.75 3.75 0 110-7.5 3.75 3.75 0 010 7.5zm21 0a3.75 3.75 0 110-7.5 3.75 3.75 0 010 7.5z",
    fill: "#fff"
  })));
}
export default SvgMore;